import { FunctionComponent, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { TokenPurpose } from "@/enum";
import AppLogo from "@/assets/images/favicon.png";

import { ROUTE_CONFIG } from "@/routes/config";

import { Button } from "@/components/Button/Button";
import { ButtonSize } from "@/components/Button/types";

import { useConfirmEmailMutation } from "../../redux/auth.api";

import { confirmEmailRefusal } from "./confirmEmailRefusal";

export const ConfirmEmail: FunctionComponent = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [confirmEmail, { isLoading }] = useConfirmEmailMutation();
	// The API refuses a change that would leave the global Admin role on another domain (PREC-4636)
	// and says why; that sentence replaces "Email confirmed.", which used to show regardless.
	const [refusal, setRefusal] = useState<string | null>(null);

	useEffect(() => {
		if (searchParams.get("token")) {
			const token = searchParams.get("token");

			confirmEmail({
				token: token || "",
				purpose: TokenPurpose.CHANGE_EMAIL,
			})
				.unwrap()
				.then(() => {
					navigate(ROUTE_CONFIG.LOGIN);
				})
				.catch((error: unknown) => {
					setRefusal(confirmEmailRefusal(error));
				});
		}
	}, [searchParams]);

	return (
		<div className={`w-full h-full flex flex-row items-center justify-center `}>
			<div className="flex flex-col bg-white p-6 rounded-[20px] w-[428px] max-w-[100%] shadow-[0px_0px_80px_0px_rgba(171,178,217,0.35)] items-center justify-center">
				<img alt="logo" className="w-[48px] h-[48px] mb-4" src={AppLogo} />
				{refusal ? (
					<>
						<div className="text-center text-md font-bold mb-4">Email not changed.</div>
						<div className="text-center text-ssm font-normal mb-8">{refusal}</div>
					</>
				) : (
					<>
						<div className="text-center text-md font-bold mb-4">Email confirmed.</div>
						<div className="text-center text-ssm font-normal mb-8">
							You will be redirected to the login page or your list overview in a few seconds.
						</div>
					</>
				)}

				<div className="w-full">
					<Button
						isLoading={isLoading}
						size={ButtonSize.ML}
						title="Login"
						onClick={() => navigate(ROUTE_CONFIG.LOGIN)}
					/>
				</div>
			</div>
		</div>
	);
};
